import { SetupChat } from '~/domain/usecases/chat/redux';
import { iActionSetup } from '~/domain/interfaces/redux/chat/setup';
import { ChatTypes } from '~/domain/interfaces/redux/chat/types';

export const chatSetup = (payload: SetupChat.Params): iActionSetup => ({
  type: ChatTypes.CHAT_SETUP,
  payload,
});
